import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product, index = 0, toImageUrl }) => {
  const {
    _id,
    productName,
    productType,
    productPrice,
    productCategory,
    mainImg,
    images,
  } = product;

  const displayImage =
    mainImg ||
    images?.[0]?.img ||
    'https://images.unsplash.com/photo-1552335457-a3154a0beec3?w=600';

  const imageUrl = toImageUrl ? toImageUrl(displayImage) : displayImage;

  return (
    <Link
      to={`/products/${_id}`}
      className="group relative block bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-500 transform hover:-translate-y-2"
      data-testid={`product-card-${index}`}
      style={{ animationDelay: `${index * 100}ms` }}
    >
      {/* Image */}
      <div className="relative aspect-square overflow-hidden bg-brand-muted/10">
        <img
          src={imageUrl}
          alt={productName}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />

        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-brand-primary/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        {/* Category */}
        {productCategory && (
          <span className="absolute top-4 left-4 bg-brand-primary text-white text-xs font-medium px-3 py-1.5 rounded-full">
            {productCategory}
          </span>
        )}

        {/* View Icon */}
        <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition">
          <Eye className="w-4 h-4 text-brand-primary" />
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="font-serif text-lg text-brand-brown group-hover:text-brand-primary transition-colors line-clamp-1">
          {productName}
        </h3>

        {productType && (
          <p className="text-sm text-brand-muted mt-1 line-clamp-2">
            {productType}
          </p>
        )}

        <p className="font-serif text-xl text-brand-primary font-semibold mt-3">
          {Number(productPrice).toFixed(2)} ₼
        </p>
      </div>
    </Link>
  );
};

export default ProductCard;